import http from "./http";

function getAllCategories() {
  return http.get(`category/`);
}

export default {
  getAllCategories,
};
